'use client';

import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import FooterWordmark from './FooterWordmark';

const AiTextIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="12" r="12" fill="#01A7FF" />
    <text
      x="50%"
      y="55%"
      textAnchor="middle"
      fill="white"
      fontSize="12"
      fontWeight="bold"
      fontFamily="Inter, Arial, sans-serif"
      dy=".3em"
    >
      AI
    </text>
  </svg>
);

const Footer = () => {
  return (
    <>
      <footer className="pt-8">
        <div className="container mx-auto px-5">
          <div className="border-t border-secondary-dark/10 py-8 flex flex-wrap justify-between items-center">
            <Link href="/">
              <Image src="/images/img_vector.svg" alt="Lensync Logo" width={115} height={24} />
            </Link>

            <div className="flex space-x-8">
              <Link href="#how-it-works" className="text-[#475467] font-semibold text-sm">
                How it works
              </Link>
              <Link href="#why-us" className="text-[#475467] font-semibold text-sm">
                Why us
              </Link>
              <Link
                href="#lensync-ai"
                className="text-[#475467] font-semibold text-sm flex items-center gap-1"
              >
                <AiTextIcon style={{ width: 18, height: 18 }} />
                LenSync AI
              </Link>
            </div>

            <Link
              href="https://www.linkedin.com/company/lensync"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                src="/images/img_linkedin_1_traced.svg"
                alt="LinkedIn"
                width={24}
                height={24}
              />
            </Link>
          </div>

          <div className="flex justify-between items-center mt-4 pb-6">
            <p className="text-[#475467] text-xs">@2024 Lensync. All Rights Reserved.</p>
            <div className="flex space-x-6">
              <Link href="/privacy-policy" className="text-[#475467] text-sm">
                Privacy Policy
              </Link>
              <Link href="/terms" className="text-[#475467] text-sm">
                Terms and conditions
              </Link>
            </div>
          </div>
        </div>
        <FooterWordmark />
      </footer>
    </>
  );
};

export default Footer;
